var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10427",
    "data-name": "Group 10427",
    transform: "translate(-142 -1621)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    transform: "translate(142 1621)",
    fill: "rgba(17,163,119,0.08)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_strongbox",
    "data-name": "vuesax/outline/strongbox",
    transform: "translate(1.625 1204.624)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "strongbox",
    transform: "translate(164 440)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.483,32.028H11.545C3.456,32.028,0,28.572,0,20.483V11.545C0,3.456,3.456,0,11.545,0h8.938c8.089,0,11.545,3.456,11.545,11.545v8.938C32.028,28.572,28.572,32.028,20.483,32.028ZM11.545,2.235c-6.867,0-9.31,2.443-9.31,9.31v8.938c0,6.867,2.443,9.31,9.31,9.31h8.938c6.867,0,9.31-2.443,9.31-9.31V11.545c0-6.867-2.443-9.31-9.31-9.31Z",
    transform: "translate(1.862 1.862)",
    fill: "#3e4143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.663,13.582A2.988,2.988,0,0,1,1.683,10.6V8.219A4.549,4.549,0,0,1,.06,5.314,4.309,4.309,0,0,1,0,4.644,4.607,4.607,0,0,1,1.817.964,4.7,4.7,0,0,1,5.9.16,4.652,4.652,0,0,1,9.162,3.422a4.493,4.493,0,0,1,.1,1.892A4.619,4.619,0,0,1,7.642,8.2v2.383A2.991,2.991,0,0,1,4.663,13.582ZM4.648,2.23a2.331,2.331,0,0,0-1.475.506,2.406,2.406,0,0,0-.939,1.907,1.064,1.064,0,0,0,.03.313A2.4,2.4,0,0,0,3.4,6.7l.521.328V10.6a.745.745,0,0,0,1.49,0V7.027L5.929,6.7A2.381,2.381,0,0,0,7.046,5v-.03A2.123,2.123,0,0,0,7,4,2.374,2.374,0,0,0,5.318,2.32,2.592,2.592,0,0,0,4.648,2.23Z",
    transform: "translate(13.214 11.087)",
    fill: "#11a377"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H11.4V2.235H0Z",
    transform: "translate(21.377 15.135)",
    fill: "#3e4143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H11.4V2.235H0Z",
    transform: "translate(2.979 15.135)",
    fill: "#3e4143"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H35.752V35.752H0Z",
    fill: "none",
    opacity: 0
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag-icon.4fe3f2d38cb7a4245dadf949bd1bc685.svg";
export { ForwardRef as ReactComponent };